import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'
import { Router } from '@angular/router'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { Observable } from 'rxjs'
import { take, tap } from 'rxjs/operators'

import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { Member } from 'src/app/features/member/member'
import { UserRole } from 'src/app/features/role/user-role/user-role'
import { Subscription } from 'src/app/features/subscription/subscription'
import { subscriptionSelectors } from 'src/app/features/subscription/subscription.selectors'
import { SubscriptionService } from 'src/app/features/subscription/subscription.service'
import { Constants } from 'src/app/shared/constants'
import { environment } from 'src/environments/environment'

@UntilDestroy()
@Component({
  selector: 'subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionListComponent implements OnInit {
  @Input() set subscriptionIds(value: number[]) {
    this.checkFilteredSubscriptionIds(value)
  }
  @Input() member: Member
  @Input() orgCategoryByUserRole: number
  @Input() configOption: any
  @Output() subscriptionClicked = new EventEmitter<void>()

  public subscriptionEntities$: Observable<Dictionary<Subscription>>
  public subscriptionEntities: Dictionary<Subscription>
  public moduleConfig = environment.moduleConfigs
  public isLoadedAndFiltered: boolean = false

  public filteredSubscriptionIds: number[] = []
  public showAllSubscription: boolean = false
  public currentDateISOString = moment()
  public moment = moment

  constructor(
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private router: Router,
    private subscriptionService: SubscriptionService
  ) {
    this.subscriptionEntities$ = this.store.select(
      subscriptionSelectors.selectEntities
    )
  }

  ngOnInit() {
    // this.filteredSubscriptionIds = this.subscriptionIds
  }
  private checkFilteredSubscriptionIds(value) {
    if (!value || value?.length === 0) {
      this.filteredSubscriptionIds = []
      return
    }

    this.subscriptionEntities$.pipe(take(1)).subscribe((subscriptions) => {
      this.filteredSubscriptionIds = value.filter((subId) => {
        const sub = subscriptions[subId]

        if (!sub) {
          return false
        }

        if (!sub.isActive) {
          return false
        }

        if (
          this.subscriptionService.getPriceForMember(
            sub,
            this.member,
            this.orgCategoryByUserRole,
            false,
            this.configOption
          ) === Constants.HIDE_ITEM_PRICE
        ) {
          return false
        }

        if (moment(sub.visibleFromDate).valueOf() > moment().valueOf()) {
          return false
        }
        if (
          sub.visibleTillDate
            ? moment(sub.visibleTillDate).valueOf() < moment().valueOf()
            : false
        ) {
          return false
        }

        if (!sub.availableTillDate) {
          return true
        }

        if (moment(sub.availableTillDate).valueOf() < moment().valueOf()) {
          return false
        }

        return true
      })
      this.isLoadedAndFiltered = true
    })
  }
  public getPrice(s: Subscription): number {
    const value = this.subscriptionService.getPriceForMember(
      s,
      this.member,
      this.orgCategoryByUserRole,
      false,
      this.configOption
    )

    return value
  }

  public isSubscriptionAvailable(s: Subscription): boolean {
    if (!s?.availableTillDate) {
      return true
    }
    return moment(s?.availableTillDate).isSameOrAfter(moment())
  }

  public onSubscriptionClicked(subscriptionID: number) {
    if (this.moduleConfig.subscriptionModule.isActive && subscriptionID) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/subscriptions/${subscriptionID}`])
      )

      window.open(url, '_blank')
      this.subscriptionClicked.emit()
    } else {
      this.notificationService.emit(
        'subscriptionModule.imposibleNavigate',
        'warning'
      )
    }
  }
}
